// extracted by mini-css-extract-plugin
module.exports = {"notice":"notice-1ZhwW","message":"message-z8bzN","pill-row":"pill-row-32Qxt","pillRow":"pill-row-32Qxt","pill":"pill-zobjC","icon":"icon-38gAQ"};